import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Form, Input, Label, Row, Table} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {formatarReal, formatarValorReal} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import moment from "moment/moment";

@inject("store")
@observer
export class ResumoLancamento extends Component {

    static propTypes = {
        controller: PropTypes.object,
        isEditavel: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {
        const resumoHE = [];
        const resumoHNOT = [];
        const totaisHorasExtras = this.controller.timesheet.totaisHorasExtras;
        const resumoHorasNoturnas = _.find(totaisHorasExtras, (h) => { return h.codigo.includes("HNOT");});
        const quantidadeTotalHE = this.controller.quantidadeTotalHE;
        const quantidadeTotalHNOT = this.controller.quantidadeTotalHNOT;
        const valorTotalHESemHNOT = this.controller.valorTotalHESemHNOT;
        const valorTotalHNOT = this.controller.valorTotalHNOT;

        totaisHorasExtras.map((r, index) => {
            if(!r.codigo.includes("HNOT")) {
                resumoHE.push(
                    <tr key={index}>
                        <td>{r.descricao}</td>
                        <td>{Number(r.horas).toFixed(2)}</td>
                        {this.props.isEditavel ? (
                            <td style={{padding: 0}}>
                                <NumberFormat
                                    allowNegative={false}
                                    value={r.valor}
                                    thousandSeparator={'.'}
                                    className="form-control"
                                    decimalSeparator={','}
                                    prefix={'R$ '}
                                    decimalPrecision={2}
                                    onChange={(event, values) => this.controller.setValorHEDadosResumo(values.floatValue, r.codigo)}
                                />
                            </td>
                        ) : (
                            <td>{formatarValorReal(r.valor)}</td>
                        )}
                    </tr>
                );
            }else{
                resumoHNOT.push(
                    <tr key={index}>
                        <td>{r.descricao}</td>
                        <td>{Number(r.horas).toFixed(2)}</td>
                        {this.props.isEditavel ? (
                            <td style={{padding: 0}}>
                                <NumberFormat
                                    allowNegative={false}
                                    value={r.valor}
                                    thousandSeparator={'.'}
                                    className="form-control"
                                    decimalSeparator={','}
                                    prefix={'R$ '}
                                    decimalPrecision={2}
                                    onChange={(event, values) => this.controller.setValorHEDadosResumo(values.floatValue, r.codigo)}
                                />
                            </td>
                        ) : (
                            <td>{formatarValorReal(r.valor)}</td>
                        )}
                    </tr>
                );
            }
        });

        return (
            <div>
                <h4>Resumo</h4>
                <Row>
                    <Col xs={12} md={3} lg={3}>
                        <FormGroup>
                            <Label>Quantidade dias apurados</Label>
                            <Input type="text" value={this.controller.quantidadeDias} readOnly/>
                        </FormGroup>
                    </Col>
                    {this.props.isEditavel ? (
                        <Col xs={12} md={3} lg={3}>
                            <FormGroup>
                                <Label>Valor salário</Label>
                                <NumberFormat allowNegative={false} value={this.controller.timesheet.valorSalario}  thousandSeparator={'.'}
                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setValorSalario(values.floatValue)}/>
                            </FormGroup>
                        </Col>
                    ) : (
                        <Col xs={12} md={3} lg={3}>
                            <FormGroup>
                                <Label>Valor salário</Label>
                                <Input type="text" value={formatarValorReal(this.controller.timesheet.valorSalario)} readOnly/>
                            </FormGroup>
                        </Col>
                    )}
                </Row>
                <Row>
                    <Col xs={12} md={3} lg={3}>
                        <FormGroup>
                            <Label>Quantidade faltas</Label>
                            <Input type="text" value={this.controller.quantidadeFaltas} readOnly/>
                        </FormGroup>
                    </Col>
                    {this.props.isEditavel ? (
                        <Col xs={12} md={3} lg={3}>
                            <FormGroup>
                                <Label>Desconto faltas</Label>
                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.descontoFaltas", 0) != null ? _.get(this.controller, "timesheet.descontoFaltas", 0): 0}  thousandSeparator={'.'}
                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDescontoFaltas(values.floatValue)}/>
                            </FormGroup>
                        </Col>
                    ) : (
                        <Col xs={12} md={3} lg={3}>
                            <FormGroup>
                                <Label>Desconto faltas</Label>
                                <Input type="text" value={formatarValorReal(this.controller.timesheet.descontoFaltas)} readOnly/>
                            </FormGroup>
                        </Col>
                    )}
                </Row>
                <Table bordered className="read-only" style={{backgroundColor: "#eceeef"}}>
                    <thead>
                    <tr>
                        <th>Tipo de hora</th>
                        <th>Horas extras</th>
                        <th>Valor</th>
                    </tr>
                    </thead>
                    <tbody>
                    {resumoHE}
                    <tr>
                        <th>Total horas</th>
                        <th>{quantidadeTotalHE}</th>
                        <th>{formatarValorReal(valorTotalHESemHNOT)}</th>
                    </tr>
                    </tbody>
                    {resumoHNOT}
                    <tfoot>
                    <tr>
                        <th>Total adicional noturno</th>
                        <th>{quantidadeTotalHNOT}</th>
                        <th>{formatarValorReal(valorTotalHNOT)}</th>
                    </tr>
                    </tfoot>
                </Table>
            </div>
        )
    }
}